const getVarcharEight = () =>
  Array.apply(0, Array(8))
    .map(() => ((charset) => charset.charAt(Math.floor(Math.random() * charset.length)))('ABCDEFGHIJKLMNPQRSTUVWXYZ123456789'))
    .join('');

export default getVarcharEight;
